import classnames from "classnames";

import "./styles.scss";

const Body = ({ size, ...props }) => (
  <div
    {...props}
    className={classnames(
      "neeto-molecules-builder-questions-list-panel__scroll",
      {
        "neeto-molecules-builder-questions-list-panel__scroll--small":
          size === "small",
      }
    )}
  />
);

export default Body;
